import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useAdminUpdateFavoriteSystemPlaybook = () => {
  const { call, isLoading: isUpdatingFavorite } = useApiPrivateRequest();

  const updateFavoriteSystemPlaybook = async (
    id: string,
    isFavorite: boolean,
  ) => {
    await call(
      `/admin/playbooks/${id}/favorite`,
      isFavorite ? "POST" : "DELETE",
      undefined,
      undefined,
    );
  };

  return {
    updateFavoriteSystemPlaybook,
    isUpdatingFavorite,
  };
};
